// extracted by mini-css-extract-plugin
module.exports = {"cookieText":"AppCookieConsent_cookieText__A_W5-","cookieButton":"AppCookieConsent_cookieButton__33MFo"};